import videojs from 'video.js';
const VideoComponent = videojs.getComponent('Component');

/**
 * 下一条视频面板
 */
class NextVideoPanel extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        // console.log(player, options);
        this.nextVideoInfo = options.nextVideoInfo;
        if (this.nextVideoInfo) {
            this.initNextVideoInfo(this.nextVideoInfo);
        }
        this.on('click', this.clickNext);
    }

    // 点击跳转
    clickNext() {
        const { nextLink } = this.nextVideoInfo;

        if (nextLink) {
            window.location.href = nextLink;
        }
    }

    createEl() {
        const btnContainer = super.createEl('div', {
            className: 'vjs-next-video-panel vjs-control',
        });

        return btnContainer;
    }

    initNextVideoInfo(videoInfo) {
        const { thumbnail, duration, desc } = videoInfo;

        const videoInfoDom = `<div class="vjs-next-video-info-box">
                                <div class="nextVideoLeft">
                                    <div class="js_videonext_img">
                                        <img src="${thumbnail}" width="100%" height="100%"></div>
                                    <div class="nextVideoTime" id="js_videonext_time">${duration}</div>
                                </div>
                                <div class="nextVideoRight">
                                    <p class="title">下一个</p>
                                    <p class="content" id="js_videonext_abstract">${desc}</p>
                                </div>
                            </div>`;

        this.el().innerHTML = videoInfoDom;
    }
}

videojs.registerComponent('NextVideoPanel', NextVideoPanel);
